import { TANGRAM_BASE_V1, TANGRAM_COLORS } from "@/lib/tangram";

// Complete assembled 7-piece Tangram, scaled uniformly as one unit.
// Reuses the canonical TANGRAM_BASE_V1 geometry (no second geometry definition).
// outline=true renders a colorless, white-stroke version (used on dark headers).
export function TangramIcon({ size = 22, className = "", outline = false, stroke = "#fff" }) {
  return (
    <svg viewBox="0 0 1000 1000" width={size} height={size} className={className} aria-hidden="true" focusable="false">
      {Object.keys(TANGRAM_BASE_V1).map((k) => (
        <polygon
          key={k}
          points={TANGRAM_BASE_V1[k]}
          fill={outline ? "none" : TANGRAM_COLORS[k]}
          stroke={outline ? stroke : "#fff"}
          strokeWidth="30"
          strokeLinejoin="miter"
        />
      ))}
    </svg>
  );
}
